/** KPI de carteira inativa de clientes */
export class CarteiraInativa {
    // Clientes Carteira
    quantidadeClientesCarteira: number;
    // Clientes Inativos
    quantidadeClientesInativos: number;
    percTaxaInativos: number;
    valorReceitaMediaClientesInativos: number;
    // Clientes Não Inativos
    quantidadeClientesNaoInativos: number;
    percTaxaNaoInativos: number;

    constructor(props: Partial<CarteiraInativa>) {
        Object.assign(this, props);
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): CarteiraInativa {
        return new CarteiraInativa(JSON.parse(json));
    }
}
